import React from 'react';
import { X } from 'lucide-react';
import { getContent, COLORS, FONTS } from '../shared/ContentData';

const ContentPanel = ({ activeSection, setActiveSection, isMobile }) => {
  if (!activeSection) return null;

  const content = getContent(activeSection);
  if (!content) return null;

  const mobileStyle = {
    position: 'fixed',
    top: '64px',
    left: '5%',
    right: '5%',
    bottom: '20px',
    backgroundColor: COLORS.content,
    padding: '20px',
    borderRadius: '15px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    overflowY: 'auto',
    zIndex: 30,
    transform: 'translateY(0)',
    transition: 'transform 0.3s ease',
    fontFamily: FONTS.primary,
    color: COLORS.text
  };

  const desktopStyle = {
    position: 'fixed',
    left: '40%',
    right: '6%',
    top: '50%',
    transform: 'translateY(-50%)',
    height: '500px',
    backgroundColor: COLORS.content,
    padding: '30px',
    borderRadius: '15px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    opacity: 1,
    transition: 'opacity 0.3s ease',
    fontFamily: FONTS.primary,
    color: COLORS.text,
    zIndex: 20,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: COLORS.text,
    padding: '8px',
    zIndex: 30
  };

  const contentStyle = isMobile ? mobileStyle : desktopStyle;

  const renderContent = () => {
    return (
      <div style={{ height: '100%', overflowY: 'auto', paddingRight: '15px' }}>
        <h2 style={{ 
          fontSize: isMobile ? '24px' : '28px', 
          marginBottom: '20px',
          fontFamily: FONTS.primary
        }}>
          {content.content.title}
        </h2>
        
        {content.content.description?.map((paragraph, index) => (
          <p key={index} style={{ 
            marginBottom: '15px',
            lineHeight: '1.6',
            fontSize: isMobile ? '16px' : '18px'
          }}>
            {paragraph}
          </p>
        ))}

        {content.content.sections?.map((section, index) => (
          <div key={index} style={{ marginBottom: '20px' }}>
            {section.title && (
              <h3 style={{ 
                fontSize: isMobile ? '20px' : '22px', 
                marginBottom: '10px',
                marginTop: '20px'
              }}>
                {section.title}
              </h3>
            )}
            {section.content?.map((paragraph, pIndex) => (
              <p key={pIndex} style={{ 
                marginBottom: '15px',
                lineHeight: '1.6',
                fontSize: isMobile ? '16px' : '18px'
              }}>
                {paragraph}
              </p>
            ))}
            {section.description?.map((paragraph, pIndex) => (
              <p key={pIndex} style={{ 
                marginBottom: '15px',
                lineHeight: '1.6',
                fontSize: isMobile ? '16px' : '18px'
              }}>
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div 
      style={contentStyle}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={() => setActiveSection(null)}
        style={closeButtonStyle}
        aria-label="Close content panel"
      >
        <X size={18} />
      </button>
      {renderContent()}
    </div>
  );
};

export default ContentPanel;